import request from '@apps-common/js-client/api/request';

import {PDA_ADMIN_URL} from '@explorer/config';

export const getPlanSubscriptions = () =>
  request
    .get(`${PDA_ADMIN_URL}/my/subscriptions`)
    .then(response => response.data);
